import React from 'react';
import { getPayTypesFromJob } from 'utils/fieldglass';

import { Grid, Typography } from '@mui/material';

import { Job } from '@libs/graphql-types';
import { modelPath } from '@libs/helpers/form';
import { ConnectedSelect } from '@libs/ui/components/form/select';

import { ApplicationFormState } from '../../types';

interface BayerWorkerPayTypeProps {
  job: Job;
  showOnlyRequired?: boolean;
}

// Bayer-specific worker pay type options
// const BAYER_WORKER_PAY_TYPE_OPTIONS = [
//   { text: 'Recruited Worker Pay Type', value: 'Recruited Worker Pay Type' },
//   { text: 'Payrolled Worker Pay Type', value: 'Payrolled Worker Pay Type' },
// ];

/**
 * Bayer-specific Worker Pay Type form component
 * This component renders a custom worker pay type form for Bayer job applications
 * with Bayer-specific worker pay type options and labeling
 */
export const BayerWorkerPayType: React.FC<BayerWorkerPayTypeProps> = ({
  job,
  showOnlyRequired = false,
}) => {
  const payRates = getPayTypesFromJob(job, 'ST').map((i) => ({
    text: i,
    value: i,
  }));

  return (
    <>
      <Grid item>
        <Typography variant="h6" gutterBottom>
          Bayer Worker Pay Type Information{' '}
          <Typography component="span" color="error">
            *
          </Typography>
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          Please select the appropriate Bayer worker pay type for this position.
        </Typography>
      </Grid>

      <Grid item>
        <ConnectedSelect
          name={modelPath<ApplicationFormState>((i) => i.details.workerPayType)}
          options={payRates}
          fullWidth
          hideNoneValue
          variant="filled"
          label={
            <Typography>
              Bayer Worker Pay Type{' '}
              <Typography component="span" color="error">
                *
              </Typography>
            </Typography>
          }
        />
      </Grid>
    </>
  );
};
